<nav class="navbar-monex sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" (click)="onClick($event)">
    <div class="sidebar-logo">

        <div class="logo-container">
            <img src="assets/images/logo_monex_dashboard.png" alt="monex" class="px-1 pb-0 pt-1" width="241" height="95" loading="lazy">
        </div>
       <!-- <div [className]="'circle-blue cursor-pointer'">
            <div class="inner-circle"></div>
        </div>-->
    </div>
    <div class="divider"></div>
    <div class="sidebar-header">
        <a routerLink="/" (click)="baseRouteClearSubMenu()" class="sidebar-brand monex-logo title-one">
            {{"BANCA_DIGITAL"|translate}}
        </a>
        <div class="sidebar-toggler not-active" #sidebarToggler (click)="toggleSidebar($event)">
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.59 12L14 10.59L9.42 6L14 1.41L12.59 2.03061e-06L6.59 6L12.59 12Z" fill="white"/>
                <path d="M6 12L7.41 10.59L2.83 6L7.41 1.41L6 2.03061e-06L4.24384e-06 6L6 12Z" fill="white"/>
            </svg>
        </div>
    </div>
    <div class="justify-content-center">
        <div  [className]="'circle-blue cursor-pointer'">
            <div class="inner-circle"></div>
        </div>
        <div class="divider-white"></div>
        <p-panelMenu [model]="items" [multiple]="false"></p-panelMenu>
    </div>

 </nav>

